import { render, staticRenderFns } from "./shipment-icon.vue?vue&type=template&id=6a80b6d9"
import script from "./shipment-icon.vue?vue&type=script&lang=js"
export * from "./shipment-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports